import styled from "styled-components";

const PayrollHero = styled.div`
  color: #3F5261;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  max-height: 800px;
  max-width: 1440px;
  margin: auto;
  
  ${(props) => props.theme.media.sm} {
    display: flex;
    flex-direction: column;
  }
  
  ${(props) => props.theme.media.md} {
    padding-top: 60px;
    min-height: 600px;
    overflow: hidden;
  }

  ${(props) => props.theme.media.lg} {
    max-height: 600px;
    padding: 60px 0;
    flex-direction: row;
  }

  .large-image-container {
    display: none;

    ${props => props.theme.media.lg} {
      display: block;
    }

    .large-hero-image {
      ${props => props.theme.media.lg} {
        margin-top: 32px;
        margin-left: 100px;
      }

      ${props => props.theme.media.xl} {
        margin-top: 38px;
        max-height: 100%;
      }
    }
  }

  .small-image-container {
    max-height: 300px;
    ${props => props.theme.media.lg} {
      display: none;
    }

    .small-hero-image {
      max-height: 305px;
      
      ${props => props.theme.media.xs} {
        max-height: 320px;
      }

    }
  }

  .container {
    ${props => props.theme.media.md} {
      max-height: 600px;
    }
    ${props => props.theme.media.xl} {
      padding-right: 50px;
      padding-right: 200px;
    } 
  }

  h1 {
    color: #3F5261;
    font-weight: 600;
    margin-bottom: ${(props) => props.Short && "10px"};
    width: 90%;
    margin: auto;
    line-height: 1;
    font-size: 40px;
    font-family: Poppins;

    ${props => props.theme.media.lg} {
      width: 100%;
      font-size: 3.5rem;
    }
  }
  .sub-header {
    font-family: Poppins;
    width: 357px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
    padding-top: 10px;
    font-size: 18px;
    line-height: 23px;

    ${props => props.theme.media.md} {
      width: 100%;
      font-size: 18px;
    }

    ${props => props.theme.media.lg} {
      font-size: 1.375rem;
      width: 100%;
      max-width: 545px;
      padding-top: 0;
    }

  }

  .sub-text {
    ${props => props.theme.media.lg} {
      font-size: 24px;
    }
  }

  .job-title {
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 3em;
  }
  p {
    color: #3F5261;
    font-weight: 300;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.9375rem;
    ${(props) => props.theme.media.lg} {
      font-size: 1.375rem;
    }
    &.full-width {
      max-width: 100%;
    }
  }
  ul,
  ol {
    max-width: 700px;
    margin: 1em auto;
  }
  .btn {
    margin-top: 15px;
    width: 80%;

    ${props => props.theme.media.lg} {
      margin-top: 40px;
      width: 460px;
      font-size: 30px;
    }
  }


  .btn-wrap {
    max-width: 22rem;
    margin: 0 auto;

    ${(props) => props.theme.media.md} {
      display: block;
      margin: 0 auto;
      max-width: 22rem;
    }
  }

  .col-md-8 {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    ${props => props.theme.media.sm} {
      padding-bottom: 10px;
    }
  }

  .btn {
    position: absolute;
    top: 100px;

    ${props => props.theme.media.lg} {
      position: initial;
    }
  }
`;

export default PayrollHero;
